const KEY_SPLASH_SCREEN = "show_splash";

export const setDisplaySplashScreen = (isShow: boolean = false) => {
  localStorage.setItem(KEY_SPLASH_SCREEN, isShow ? "1" : "0");
};

export const isDisplayedSplashScreen = (): boolean => {
  return String(localStorage.getItem(KEY_SPLASH_SCREEN) || "0") === "1";
};
